module.exports = __webpack_public_path__ + "static/media/christin-hume-311288-unsplash@2x.47feb59c.png";